import React from 'react';
import { AGGREGATE } from '@/util/enums/EnumLayers';
import { LayerAggregateReadOnlyMode } from '@/components/layers/LayerAggregate/subcomponents/LayerAggregateReadOnlyMode';
import Layer from './Layer';
import ModalAggregate from '../modals/ModalAggregate';
import InlineAggregateLayer from './InlineAggregateLayer';

class LayerAggregate extends Layer {
  constructor(
    keys,
    functions,
    extraColumns,
    pks,
    useDatetimeColumnAsDatetimeColumnAggregate,
  ) {
    super(AGGREGATE);
    this._keys = keys; // AggregateColumn objs
    this._functions = functions; // list of AggregateFunction objs
    this._extraColumns = extraColumns; // list of ColumnName objs
    this._pks = pks; // list of ColumnName objs
    this._useDatetimeColumnAsDatetimeColumnAggregate =
      useDatetimeColumnAsDatetimeColumnAggregate;
  }

  //
  // Even this old-world layer could be a template (if it was created in new world, but opened in old world)
  isTemplate() {
    return this.keys().length === 0 && this.functions().length === 0;
  }

  static buildFromState(state) {
    const groupByKeys = state.selected; // AggregateColumn objs
    const functions = state.aggFunctions;
    const { extraColumns } = state;
    const { pks } = state;
    const { useDatetimeColumnAsDatetimeColumnAggregate } = state;
    return new InlineAggregateLayer(
      groupByKeys,
      functions,
      extraColumns,
      pks,
      useDatetimeColumnAsDatetimeColumnAggregate,
    );
  }

  modal() {
    return ModalAggregate;
  }

  keys() {
    return this._keys;
  }

  count() {
    return this._count;
  }

  functions() {
    return this._functions;
  }

  extraColumns() {
    return this._extraColumns;
  }

  pks() {
    return this._pks;
  }

  useDatetimeColumnAsDatetimeColumnAggregate() {
    return this._useDatetimeColumnAsDatetimeColumnAggregate;
  }

  buildContent(editLayerClicked, aliases = {}) {
    return (
      <LayerAggregateReadOnlyMode
        aliases={aliases}
        keys={this.keys()}
        pks={this.pks()}
        functions={this.functions()}
        layerId={this.id()}
        editLayerClicked={editLayerClicked}
      />
    );
  }
}

export default LayerAggregate;
